import styledComponents from 'styled-components'

export default styledComponents.h1.attrs({ className: 'title' })``



// WEBPACK FOOTER //
// ./src/components/views/typo/Title.js